import type {ExecutorService} from '@shared/types/Executors'

interface Props {
    services: ExecutorService[]
    header: string | null
    priceLabel: string
    className?: string
}

// Список оказываемых услуг исполнителя.
export function ExecutorServices(props: Props) {

    const {
        services,
        header,
        priceLabel,
        className,
    } = props

    return (
        <div className={className}>
            {header && (
                <div className="text-muted">
                    {header}:
                </div>
            )}
            <ul className="m-0">
                {services.map(service => (
                    <li key={service.id}>
                        <div className="d-flex flex-column d-sm-block">
                            <span>{service.title}</span>
                            <span className="text-nowrap">
                                <span className="d-none d-sm-inline-block mx-sm-1">/</span>
                                <span className="text-muted me-1">
                                    {priceLabel}:
                                </span>
                                {renderPrice(service)}
                            </span>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}

function renderPrice(service: ExecutorService) {
    switch (service.priceType) {
        case 'variable':
            return (
                <span>
                    {service.priceTypeLabel?.toLowerCase()}
                </span>
            )
        case 'fixed':
            return (
                <span>
                    {service.minPrice} {service.priceUnitLabel?.toLowerCase() ?? ''}
                </span>
            )
        case 'range':
            return (
                <span>
                    {service.minPrice} - {service.maxPrice} {service.priceUnitLabel?.toLowerCase() ?? ''}
                </span>
            )
    }
}
